// tslint:disable-next-line:no-any
export function isEmptyArray<T>(value: any): value is T[] {
  return Array.isArray(value) && value.length === 0;
}
